import { useState } from 'react'
import { ArrowLeftIcon } from '@phosphor-icons/react'
import { ScoopButton, ScoopChip, ScoopText, ScoopColumn, ScoopRow, ScoopStepper } from '../../ui'
import ScoopLogo from '../../../assets/common/NewLogo.svg'
import { ChooseRecipe } from './RecipeFlow/ChooseRecipe/ChooseRecipe'
import { SelectSource } from './RecipeFlow/SelectSource/SelectSource'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../../router/routes'
import { ConnectSource } from './RecipeFlow/ConnectSource/ConnectSource'
import { MatchFields } from './RecipeFlow/MatchFields/MatchFields'
import styles from './Recipe.module.scss'

export const Recipe = () => {
    const [step, setStep] = useState(0)
    const [selectedRecipe, setSelectedRecipe] = useState(null)
    const [selectedSource, setSelectedSource] = useState(null)
    const navigate = useNavigate()

    const handleGoBack = () => {
        if (step === 0) navigate(ROUTES.LOGIN)
        setStep(step - 1)
    }

    const handleSelectRecipe = (recipe) => {
        setSelectedRecipe(recipe)
        setStep(1)
    }

    const renderSteps = () => {
        switch (step) {
            case 0:
                return <ChooseRecipe selectRecipe={handleSelectRecipe} />
            case 1:
                return (
                    <>
                        {renderStepper()}
                        <SelectSource
                            source={selectedSource}
                            goNext={() => setStep(2)}
                            selectSource={(source) => setSelectedSource(source)}
                        />
                    </>
                )
            case 2:
                return (
                    <>
                        {renderStepper()}
                        <ConnectSource goForward={() => setStep(3)} source={selectedSource} />
                    </>
                )
            case 3:
                return (
                    <>
                        {renderStepper()}
                        <MatchFields source={selectedSource} goBack={handleGoBack} />
                    </>
                )
            default:
                return <></>
        }
    }

    const renderStepper = () => {
        const steps = ['Prepare Data', 'Scoop Data', 'Match Fields', 'Complete']

        return (
            <ScoopColumn className={styles.stepperSection}>
                <ScoopColumn className={styles.stepperHeader}>
                    <ScoopColumn className={styles.stepperTitleWrapper}>
                        <ScoopChip label="New Workspace" size="small" />
                        <ScoopText className={styles.recipeTitle}>
                            {selectedRecipe.title + ' Recipe'}
                        </ScoopText>
                    </ScoopColumn>
                </ScoopColumn>
                <div className={styles.stepperWrapper}>
                    <ScoopStepper steps={steps} activeStep={step - 1} />
                </div>
            </ScoopColumn>
        )
    }

    return (
        <div className={styles.recipeContainer}>
            <RecipeNavbar goBack={handleGoBack} showIcon={step >= 1} />
            <div className={styles.contentWrapper}>{renderSteps()}</div>
        </div>
    )
}

export const RecipeNavbar = ({ showIcon, goBack }) => {
    return (
        <ScoopRow className={styles.navbar} justify="space-between" align="center">
            <ScoopButton
                onClick={goBack}
                variant="grey"
                size="sm"
                className={styles.backButton}
                leftSection={<ArrowLeftIcon size={16} />}
            >
                <span className={styles.backButtonText}>Back</span>
            </ScoopButton>
            {showIcon && (
                <div>
                    <img alt="scoop logo" src={ScoopLogo} />
                </div>
            )}
        </ScoopRow>
    )
}
